import { useAllUserGroups } from "./useAllUserGroups.ts";

export function useUserGroupName() {
  const { userGroups } = useAllUserGroups();
  return (userGroupId: string | null | undefined): string => {
    if (!userGroupId) return "—";
    return userGroups.find((g) => g.id === userGroupId)?.name ?? userGroupId;
  };
}
